export default "__VITE_ASSET__d2725955__"